import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import userImage from "../../../assets/images/user4_2x.png";
import Button from "@material-ui/core/Button";
import { AuthContext } from "../../../context/AuthContext";

const useStyles = makeStyles((theme) => ({
  rightAlign: {
    textAlign: "right",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  uploadButtonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  backButton: {
    fontSize: "16px",
    textTransform: "capitalize",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },

  marginRightStyle: {
    marginRight: 15,
  },

  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  imageStyle: {
    borderRadius: "50%",
  },
  imageDivStyle: {
    margin: "30px 0 20px",
  },
  divMarginStyle: {
    margin: "40px 0",
  },
}));

const ProfileSettings = () => {
  const classes = useStyles();
  const { glob_pay_agent_auth } = useContext(AuthContext);

  return (
    <>
      <Typography variant="h5" gutterBottom>
        {glob_pay_agent_auth.user.name}
      </Typography>
      <Typography variant="body1">
        Only you can view the changes that has been made
      </Typography>
      <div className={classes.imageDivStyle}>
        <img
          src={
            glob_pay_agent_auth.user.picture
              ? glob_pay_agent_auth.user.picture
              : userImage
          }
          alt=""
          height="147px"
          className={classes.imageStyle}
        />
      </div>
      <Button
        variant="outlined"
        color="primary"
        className={classes.uploadButtonStyle}
      >
        Upload Picture
      </Button>
      {/* <div className={classes.divMarginStyle}>
        <Typography variant="body1" gutterBottom>
          Your Display Name
        </Typography>
        <TextField
          id="transaction-id"
          size="small"
          fullWidth
          placeholder="Enter Name"
          variant="outlined"
          className={classes.textField}
        />
      </div> */}
      {/* <div className={classes.rightAlign}>
        <Button
          className={`${classes.backButton} ${classes.marginRightStyle}`}
          disableRipple={true}
          onClick={() => window.history.back()}
          style={{ fontWeight: 600, padding: "10px 32px" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.buttonStyle}
        >
          Save
        </Button>
      </div> */}
    </>
  );
};

export default ProfileSettings;
